import gql from 'graphql-tag';

export default gql`
  query savedOrdersContent($moduleName: String) {
    savedOrdersContent(moduleName: $moduleName) {
      id
      Active
      DateSaved
      OrderNo
      OrderType
      OrderTypeRaw: OrderType(raw: true)
      DateSaved
      DateShip
      AcctName
      Cases
      Bottles
      Total
      Po
      Coop
      Note
      ShipTo
      Account {
        Po
        Bal
        Lic
        Rep
        Sup
        Wb1
        Wb2
        Wb3
        City
        Coop
        Days
        Last
        Prem
        Type
        Affil
        Focus
        Level
        State
        AcctNo
        County
        Growth
        Region
        Status
        Address
        DelNote
        AcctName
        AcctNote
        Wb1Email
        Wb1Phone
        Wb2Email
        Wb2Phone
        Wb3Email
        Wb3Phone
      }
      Det {
        Code
        Uom
        Description
        Qty
        Mobo
        MoboQty {
          OrderNo
          Qty
          converted
        }
      }
    }
  }
`;
